export default {
  header: 'Wybierz krok szablonu',
  submit: 'Wstaw {templateStep}',
};
